import { trackBuyflowEvent } from "src/utils/api/tracker";
import {
  glp1CoursepackOptedIn,
  isBMINoomClinicalEligible,
  isCurrentHealthRiskNoomClinicalEligible,
  isMedicareStatusNoomClinicalEligible,
  isZipcodeNoomClinicalEligible,
} from "@utils/userSegment/features";
import getStore from "src/utils/redux/store";
import { getSurveyAnswers } from "src/hooks/survey/answers";

export type MED_INELIGIBILITY_REASON =
  | "BMI"
  | "ZIPCODE"
  | "MED_COMPANION"
  | "HEALTH_RISK"
  | "SKIPPED_GENETICS_BIOLOGY_QUESTION"
  | "INSURANCE";

function determineMedIneligibilityReason():
  | MED_INELIGIBILITY_REASON
  | undefined {
  const state = getStore().getState();
  const surveyAnswers = getSurveyAnswers(state);

  if (!isBMINoomClinicalEligible()) {
    return "BMI";
  }
  if (!isMedicareStatusNoomClinicalEligible()) {
    return "INSURANCE";
  }
  if (glp1CoursepackOptedIn()) {
    return "MED_COMPANION";
  }
  if (!surveyAnswers.geneticsAndBiology) {
    return "SKIPPED_GENETICS_BIOLOGY_QUESTION";
  }
  if (!isCurrentHealthRiskNoomClinicalEligible()) {
    return "HEALTH_RISK";
  }
  if (!isZipcodeNoomClinicalEligible()) {
    return "ZIPCODE";
  }

  return undefined;
}

export const trackNoomMedEligible = (): void => {
  const medIneligibilityReason = determineMedIneligibilityReason();

  trackBuyflowEvent(
    "NoomMedEligibilityChecked",
    medIneligibilityReason
      ? { isEligibleForMed: false, medIneligibilityReason }
      : { isEligibleForMed: true }
  );
};
